export class User {
    public userName = '';
    public password = '';
    public confirmPassword = '';
    public realtorLicense = '';
    public firstName = '';
    public lastName = '';
    public userId = '';
    public isActive = false;
    public isAdmin = false;
}
